import { render, staticRenderFns } from "./ModalHolidaysForm.vue?vue&type=template&id=2003dc0d&"
import script from "./ModalHolidaysForm.vue?vue&type=script&lang=js&"
export * from "./ModalHolidaysForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports